
import MainLayout from '@/components/layout/MainLayout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ThemeToggle } from '@/components/theme/ThemeToggle';
import { Separator } from '@/components/ui/separator';
import { Button } from '@/components/ui/button';
import ExportDataButton from '@/components/data/ExportDataButton';

const Settings = () => {
  return (
    <MainLayout>
      <div className="container mx-auto p-6">
        <h1 className="text-2xl font-bold mb-2">Configurações</h1>
        <p className="text-sm text-gray-500 mb-6">Personalize sua experiência no Vive Calme</p>
        
        <div className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Aparência</CardTitle>
              <CardDescription>Personalize o visual do aplicativo</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-medium">Tema</p>
                  <p className="text-sm text-muted-foreground">
                    Escolha entre claro, escuro ou use as preferências do seu dispositivo
                  </p>
                </div>
                <ThemeToggle />
              </div>
            </CardContent>
          </Card>
          
          <Card>
            <CardHeader>
              <CardTitle>Dados</CardTitle>
              <CardDescription>Gerencie seus dados pessoais</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <ExportDataButton />
                <p className="text-sm text-muted-foreground mt-2">
                  Baixe um arquivo com todos os seus dados registrados no aplicativo
                </p>
              </div>
              <Separator />
              <div>
                <Button variant="destructive">Apagar minha conta</Button>
                <p className="text-sm text-muted-foreground mt-2">
                  Esta ação não pode ser desfeita e remove permanentemente todos os seus dados
                </p>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Notificações</CardTitle>
              <CardDescription>Configure como e quando deseja receber lembretes</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                As configurações de notificação estarão disponíveis após a conexão com o Supabase.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </MainLayout>
  );
};

export default Settings;
